import { is_iOS } from "@blacknut/javascript-sdk/dist";
import { AppLayout, StorageKey } from "core";
import React, { useCallback } from "react";
import { useOrientation, OrientationType } from "src/utils/OrientationContext";
import electronService from "../../services/ElectronService";
import SuspenseCircular from "../SuspenseCircular";

function loadContent(deviceInfos: any, orientation: OrientationType) {
  const browserName = deviceInfos.deviceInfos.browserName;
  const deviceType = deviceInfos.deviceInfos.deviceType;
  const os = deviceInfos.deviceInfos.userAgent;
  const model = deviceInfos.deviceInfos.deviceModel;

  if (
    (browserName == "chrome" && os != "android") ||
    (browserName == "chrome" &&
      orientation === "LANDSCAPE" &&
      deviceType === AppLayout.TABLET)
  ) {
    if (orientation === "LANDSCAPE" && deviceType === AppLayout.TABLET) {
      return React.lazy(() => import("./NotificationChromeMobile"));
    }
    return React.lazy(() => import("./NotificationChrome"));
  }
  if (browserName == "chrome" && os === "android") {
    return React.lazy(() => import("./NotificationChromeMobile"));
  }
  if (
    (browserName == "mobile-safari" && model === "ipad") ||
    (browserName == "safari" && is_iOS())
  ) {
    return React.lazy(() => import("./NotificationSafariIpad"));
  }
  if (browserName == "mobile-safari" && os === "ios") {
    return React.lazy(() => import("./NotificationSafariMobile"));
  }
  return React.lazy(() => Promise.resolve({ default: () => <></> }));
}

const NotificationInstall = (deviceInfos: any) => {
  const setNotificationInstall = useCallback((e: React.UIEvent<unknown>) => {
    localStorage.setItem(StorageKey.INSTALL_NOTIF, "false");
    e.stopPropagation();
    window.dispatchEvent(new Event("storage"));
  }, []);
  const { orientation } = useOrientation();
  const deviceType = deviceInfos.deviceInfos.deviceType;
  if (deviceType === "unknown" || electronService.isAvailable()) {
    return null;
  }

  const Content = loadContent(deviceInfos, orientation);

  return (
    <SuspenseCircular>
      <Content onClose={setNotificationInstall} />
    </SuspenseCircular>
  );
};
export default NotificationInstall;
